var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import BaseModel from "../BaseModel";
var LoyaltyPointsModel = /** @class */ (function (_super) {
    __extends(LoyaltyPointsModel, _super);
    function LoyaltyPointsModel(data) {
        var _this = _super.call(this, data) || this;
        var hydrated = _super.prototype.useHydrator.call(_this, data);
        _this.crDate = hydrated.crDate;
        _this.feedbacksEarned = hydrated.feedbacksEarned;
        _this.feedbacksSpent = hydrated.feedbacksSpent;
        _this.franchisorBase = hydrated.franchisorBase;
        _this.locationsVisited = hydrated.locationsVisited;
        _this.loyaltyPointsEarned = hydrated.loyaltyPointsEarned;
        _this.loyaltyPointsSpent = hydrated.loyaltyPointsSpent;
        _this.modDate = hydrated.modDate;
        _this.nextStoredValueId = hydrated.nextStoredValueId;
        _this.storedValue = hydrated.storedValue;
        return _this;
    }
    LoyaltyPointsModel.prototype.hydrate = function (data) {
        var loyaltyPoints = {};
        loyaltyPoints.crDate = data.cr_date || null;
        loyaltyPoints.feedbacksEarned = typeof data.feedbacks_earned !== undefined ? data.feedbacks_earned : null;
        loyaltyPoints.feedbacksSpent = typeof data.feedbacks_spent !== undefined ? data.feedbacks_spent : null;
        loyaltyPoints.franchisorBase = data.franchisor_base || null;
        loyaltyPoints.locationsVisited = data.locations_visited || null;
        loyaltyPoints.loyaltyPointsEarned =
            typeof data.loyalty_points_earned !== undefined ? data.loyalty_points_earned : null;
        loyaltyPoints.loyaltyPointsSpent =
            typeof data.loyalty_points_spent !== undefined ? data.loyalty_points_spent : null;
        loyaltyPoints.modDate = data.mod_date || null;
        loyaltyPoints.nextStoredValueId =
            typeof data.next_stored_value_id !== undefined ? data.next_stored_value_id : null;
        loyaltyPoints.storedValue = typeof data.stored_value !== undefined ? data.stored_value : null;
        return loyaltyPoints;
    };
    return LoyaltyPointsModel;
}(BaseModel));
export default LoyaltyPointsModel;



//////////////////
// WEBPACK FOOTER
// ./src/models/loyalty/LoyaltyPointsModel.ts
// module id = null
// module chunks = 